/**
 * "Try these photos" for Image to Video.
 *
 * Must be images we own or have a commercial licence for — never real people,
 * celebrities or children. Drop files in `public/img/samples/` and list them
 * here. While the list is empty the section is simply not shown.
 */
export interface SamplePhoto {
  /** Path under /public, e.g. '/img/samples/portrait-1.webp'. */
  url: string;
  label: string;
}

export const SAMPLE_PHOTOS: readonly SamplePhoto[] = [];
